import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { reusableFetch, reusableWithoutTokenFetch } from "@/utils/useFetch";

export const getUser = createAsyncThunk("user", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user`, "GET", null, rejectWithValue);
  return response;
});

export const updateUser = createAsyncThunk("user/update", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/`, "POST", data, rejectWithValue);
  return response;
});

export const updateUserOrg = createAsyncThunk("user/organisation", async (data, { rejectWithValue }) => {
  const response = await reusableFetch("user/organisation", "POST", data, rejectWithValue);
  return response;
});

export const updateOrganisationAclDetails = createAsyncThunk(
  "user/organisation/acl-details",
  async ({ organisationId, ...aclPayload }, { rejectWithValue }) => {
    const response = await reusableFetch(`organisation/acl/${organisationId}`, "PATCH", aclPayload, rejectWithValue);
    return response;
  },
);

export const updateUserMember = createAsyncThunk("user/member", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/member`, "POST", data, rejectWithValue);
  return response?.data;
});

export const validateToken = createAsyncThunk("validate", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/validate`, "GET", rejectWithValue);
  return response?.data;
});

export const logout = createAsyncThunk("logout", async (returnTo, { rejectWithValue }) => {
  const logoutUrl = returnTo ? `user/logout?returnTo=${encodeURIComponent(returnTo)}` : "user/logout";
  const response = await reusableFetch(logoutUrl, "GET", null, rejectWithValue);
  return response?.data;
});

export const validateEmail = createAsyncThunk("validate/email", async (email, { rejectWithValue }) => {
  const response = await reusableWithoutTokenFetch(`user/email/validate/${email}`, "GET", rejectWithValue);
  return response;
});

export const validatePhone = createAsyncThunk("validate/phone", async (phone, { rejectWithValue }) => {
  const response = await reusableWithoutTokenFetch(`user/phone/validate/${phone}`, "GET", rejectWithValue);
  return response;
});

export const updatePhoneNumber = createAsyncThunk("user/update-phoneNumber", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/phone-number`, "POST", data, rejectWithValue);
  return response;
});

export const updateSettings = createAsyncThunk("settings/update", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`settings`, "POST", data, rejectWithValue);
  return response;
});

export const sendEnquiry = createAsyncThunk("settings/update", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/enquiry`, "POST", data, rejectWithValue);
  return response;
});

export const getAllTransactions = createAsyncThunk("transactions/get", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`transactions/all`, "GET", rejectWithValue);
  return response;
});

export const createSubscription = createAsyncThunk("subscription/create", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`billing/subscription`, "POST", data, rejectWithValue);
  return response;
});

export const getCustomerBilling = createAsyncThunk("customer-billing/get", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`billing/customer`, "GET", rejectWithValue);
  return response;
});

export const getAllUsers = createAsyncThunk("all/get", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/all`, "POST", data, rejectWithValue);
  return response;
});

export const resendUserInvitation = createAsyncThunk("user/resend-invitation", async (email, { rejectWithValue }) => {
  const response = await reusableFetch(`user/resend-invitation`, "POST", { email }, rejectWithValue);
  return response;
});

export const getAllRoleDetail = createAsyncThunk("all/getAllRoleDetail", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`organisation-permission`, "GET", rejectWithValue);
  return response?.data;
});

export const getOrganisationPermissionById = createAsyncThunk(
  "all/getOrganisationPermissionById",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(`organisation-permission/orgnisation-id/${data?._id}`, "GET", rejectWithValue);
    return response?.data;
  },
);

export const getRoleById = createAsyncThunk("user/getRoleById", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`organisation-permission/${data?._id}`, "GET", rejectWithValue);
  return response?.data;
});

export const getRoleByUserId = createAsyncThunk("user/getRoleByUserId", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user-permission/${data?._id}`, "GET", rejectWithValue);
  return response?.data;
});
export const createLenderSetting = createAsyncThunk("user/createLenderSetting", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`lender-settings`, "POST", data, rejectWithValue);
  return response;
});

export const updateLenderSetting = createAsyncThunk("user/updateLenderSetting", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`lender-settings`, "PUT", data, rejectWithValue);
  return response;
});

export const deleteLenderSetting = createAsyncThunk("user/deleteLenderSetting", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`lender-settings`, "DELETE", data, rejectWithValue);
  return response;
});

export const addPaymentCredit = createAsyncThunk("user/addPaymentCredit", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user-payment-method/add-payment-method`, "POST", data, rejectWithValue);
  return response?.data;
});

export const DeletePaymentCredit = createAsyncThunk("user/DeletePaymentCredit", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user-payment-method/delete-payment-method`, "POST", data, rejectWithValue);
  return response?.data;
});

export const getPaymentMethod = createAsyncThunk("user/getPaymentMethod", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user-payment-method/get-payment-methods`, "GET", data, rejectWithValue);
  return response?.data;
});

export const getServicesCharges = createAsyncThunk("user/getServicesCharges", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`service-usage/get-service-usage`, "POST", data, rejectWithValue);
  return response?.data;
});

export const getServicesDataExport = createAsyncThunk(
  "user/getServicesUsageExport",
  async ({ url }, { rejectWithValue }) => {
    const response = await reusableFetch(`service-usage/service-usage-report${url}`, "GET", {}, rejectWithValue, false);

    return response?.data;
  },
);

export const getCommissionReport = createAsyncThunk(
  "user/getCommissionReport",
  async ({ data }, { rejectWithValue }) => {
    const response = await reusableFetch(`reporting/commission-report`, "POST", data, rejectWithValue, false);

    return response;
  },
);

export const getApplicationsDataReport = createAsyncThunk(
  "user/getApplicationsDataReport",
  async ({ data }, { rejectWithValue }) => {
    const response = await reusableFetch(`reporting/applications-data-report`, "POST", data, rejectWithValue, false);
    return response;
  },
);

export const getServicesDetail = createAsyncThunk("user/getServicesDetail", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(
    `service-usage/get-service-usage-details?serviceId=${data?.serviceId}&fromDate=${data?.fromDate || ""}&toDate=${data?.toDate || ""}`,
    "GET",
    rejectWithValue,
  );
  return response?.data;
});

export const getInVoiceList = createAsyncThunk("user/getInVoiceList", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`Invoice/get-invoice-details`, "POST", data, rejectWithValue);
  return response?.data;
});

export const getInVoiceDetail = createAsyncThunk("user/getInVoiceDetail", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`Invoice/get-invoice-data/${data?.serviceId}`, "GET", rejectWithValue);
  return response?.data;
});

export const getInVoiceDownloadUrl = createAsyncThunk(
  "user/getInVoiceDownloadUrl",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(`Invoice/invoice-download/${data?.serviceId}`, "GET", rejectWithValue);
    return response?.data;
  },
);

export const submitTerms = createAsyncThunk("user/terms", async (data, { rejectWithValue, getState }) => {
  const privacy = await reusableFetch(`user/terms`, "POST", data, rejectWithValue);
  return privacy;
});

export const acceptEmploymentIncomeVerificationTerms = createAsyncThunk(
  "user/employment-income-verification-terms",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch("employment-income-verification/terms", "POST", {}, rejectWithValue);
    return response;
  },
);

export const updateUserRole = createAsyncThunk("user/updateUserRole", async ({ userId, data }, { rejectWithValue }) => {
  const response = await reusableFetch(`user-permission/${userId}`, "PUT", data, rejectWithValue);
  return response?.data;
});

export const saveRolePermissions = createAsyncThunk(
  "user/saveRolePermissions",
  async ({ data, id }, { rejectWithValue }) => {
    const response = await reusableFetch(`organisation-permission/${id}`, "PUT", data, rejectWithValue);
    return response?.data;
  },
);

export const getOrganisationUser = createAsyncThunk(
  "user/getOrganisationUser",
  async ({ cursor, limit }, { rejectWithValue }) => {
    const response = await reusableFetch(`user-permission?cursor=${cursor}&limit=${limit}`, "GET", rejectWithValue);
    return response?.data;
  },
);

export const saveUserRolePermissions = createAsyncThunk(
  "user/saveUserRolePermissions",
  async ({ data, id }, { rejectWithValue }) => {
    const response = await reusableFetch(`user-permission/${id}`, "PUT", data, rejectWithValue);
    return response;
  },
);

export const getOrganisationSetting = createAsyncThunk(
  "user/getOrganisationSetting",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(`organisation-setting/get-organisation-setting`, "GET", rejectWithValue);
    return response?.data?.data;
  },
);

export const updateUserSetting = createAsyncThunk("user/updateUserSetting", async (data, { rejectWithValue }) => {
  const response = await reusableFetch(`user/update-setting`, "POST", data, rejectWithValue);
  return response?.data?.data;
});

export const getAllUserPermissions = createAsyncThunk(
  "user/getAllUserPermissions",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(
      `user-permission/all?cursor=${data.cursor}&limit=${data.limit}`,
      "GET",
      rejectWithValue,
    );
    return response?.data;
  },
);

export const getUserPermissionsByUserId = createAsyncThunk(
  "user/getUserPermissionsByUserId",
  async ({ userId }, { rejectWithValue }) => {
    const response = await reusableFetch(`user-permission/${userId}`, "GET", rejectWithValue);
    return response?.data;
  },
);

export const updateUserPermissions = createAsyncThunk(
  "user/getUserPermissionsByUserId",
  async ({ userId, data }, { rejectWithValue }) => {
    const response = await reusableFetch(`user-permission/${userId}`, "PUT", data, rejectWithValue);
    return response?.data;
  },
);

export const updateOrganisationSetting = createAsyncThunk(
  "user/updateOrganisationSetting",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(
      `organisation-setting/update-organisation-setting`,
      "POST",
      data,
      rejectWithValue,
    );
    return response?.data?.data;
  },
);

export const getAllUsersWithBasicInfo = createAsyncThunk(
  "user/getAllUsersWithBasicInfo",
  async (data, { rejectWithValue }) => {
    const response = await reusableFetch(`user/all-users-basic-details`, "POST", data, rejectWithValue);
    return response?.data;
  },
);

const initialState = {
  phoneInUse: false,
  emailInUse: false,
  userStatusFilter: "Active",
  isCreatingAccount: false,
  templateSaveSuccess: false,
  transactions: null,
  clientSecret: null,
  isCreatingSubscription: false,
  gettingOrganisationDetails: false,
  service_invoice_paid_by: false,
  is_users_use_org_invoice_paid_by: false,
  permissions: {},
  getAllPayments: [],
  servicesCharges: [],
  servicesDetail: [],
  inVoiceList: [],
  inVoiceDetail: [],
  isServicePaid: null,
  userRoleList: [],
  is_service_enable: false,
  servicesChargesLoader: false,
  userRoleLoader: false,
  roleById: [],
  oraganisationUser: [],
  getRoleByIdLoader: false,
  inVoiceListLoader: false,
  inVoiceDetailLoader: false,
  serviceDetailLoader: false,
  exportLoader: false,
  commissionReportLoader: false,
  applicationsDataReportLoader: false,
  oranganisationName: "",
  all: {},
  users: {
    docs: [],
  },
  usersWithBasicInfoList: [],
  usersWithBasicInfoLoader: false,
  usersLoader: false,
  gettingUsers: false,
  isResendUserEmail: {
    isSendingEmail: false,
    resendEmail: null,
  },
  isAdmin: false,
  lenderSettings: [],
  acceptingEmploymentIncomeVerificationTerms: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveValue: (state, action) => _.merge(state, action.payload),
    resetState: () => initialState,
  },
  extraReducers: {
    [getInVoiceDownloadUrl.fulfilled]: (state, { payload }) => {
      state.url = payload?.data?.invoice_pdf || payload.data.url;
    },
    [getInVoiceDownloadUrl.pending]: (state) => {},
    [getInVoiceDownloadUrl.rejected]: (state) => {},
    [getServicesCharges.fulfilled]: (state, { payload }) => {
      state.servicesCharges = payload?.data;
      state.servicesChargesLoader = false;
    },
    [getServicesCharges.pending]: (state) => {
      state.servicesCharges = [];
      state.servicesChargesLoader = true;
    },
    [getServicesCharges.rejected]: (state) => {
      state.servicesCharges = [];
      state.servicesChargesLoader = false;
    },

    [getServicesDetail.fulfilled]: (state, { payload }) => {
      state.servicesDetail = payload?.data;
      state.serviceDetailLoader = false;
    },
    [getServicesDetail.pending]: (state) => {
      state.servicesDetail = [];
      state.serviceDetailLoader = true;
    },
    [getServicesDetail.rejected]: (state) => {
      state.servicesDetail = [];
      state.serviceDetailLoader = false;
    },

    [getInVoiceList.fulfilled]: (state, { payload }) => {
      state.inVoiceList = payload?.data;
      state.inVoiceListLoader = false;
    },
    [getInVoiceList.pending]: (state) => {
      state.inVoiceListLoader = true;
      state.inVoiceList = [];
    },
    [getInVoiceList.rejected]: (state) => {
      state.inVoiceList = [];
      state.inVoiceListLoader = false;
    },

    [getInVoiceDetail.fulfilled]: (state, { payload }) => {
      state.inVoiceDetail = payload?.data;
      state.inVoiceDetailLoader = false;
    },
    [getInVoiceDetail.pending]: (state) => {
      state.inVoiceDetail = [];
      state.inVoiceDetailLoader = true;
    },
    [getInVoiceDetail.rejected]: (state) => {
      state.inVoiceDetail = [];
      state.inVoiceDetailLoader = false;
    },

    [getServicesDataExport.fulfilled]: (state, { payload }) => {
      state.exportLoader = false;
    },
    [getServicesDataExport.pending]: (state) => {
      state.exportLoader = true;
    },
    [getServicesDataExport.rejected]: (state) => {
      state.exportLoader = false;
    },

    [getCommissionReport.fulfilled]: (state) => {
      state.commissionReportLoader = false;
    },
    [getCommissionReport.pending]: (state) => {
      state.commissionReportLoader = true;
    },
    [getCommissionReport.rejected]: (state) => {
      state.commissionReportLoader = false;
    },
    [getApplicationsDataReport.fulfilled]: (state) => {
      state.applicationsDataReportLoader = false;
    },
    [getApplicationsDataReport.pending]: (state) => {
      state.applicationsDataReportLoader = true;
    },
    [getApplicationsDataReport.rejected]: (state) => {
      state.applicationsDataReportLoader = false;
    },
    [updateUserSetting.fulfilled]: (state, { payload }) => {
      state.isServicePaid = payload?.service_invoice_paid_by;
      state.service_invoice_paid_by = payload?.service_invoice_paid_by;
      state.is_users_use_org_invoice_paid_by = payload?.is_users_use_org_invoice_paid_by;
    },
    [updateUserSetting.pending]: (state) => {},
    [updateUserSetting.rejected]: (state) => {},

    [updateOrganisationSetting.fulfilled]: (state, { payload }) => {
      state.is_service_paid = payload?.service_invoice_paid_by;
    },
    [updateOrganisationSetting.pending]: (state) => {},
    [updateOrganisationSetting.rejected]: (state) => {},

    [getOrganisationSetting.fulfilled]: (state, { payload }) => {
      state.isServicePaid = payload?.service_invoice_paid_by;
    },
    [getOrganisationSetting.pending]: (state) => {},
    [getOrganisationSetting.rejected]: (state) => {},

    [getPaymentMethod.fulfilled]: (state, { payload }) => {
      state.getAllPayments = payload?.data;
    },
    [getPaymentMethod.pending]: (state) => {},
    [getPaymentMethod.rejected]: (state) => {
      state.getAllPayments = [];
    },

    [addPaymentCredit.fulfilled]: (state, { payload }) => {},
    [addPaymentCredit.pending]: (state) => {},
    [addPaymentCredit.rejected]: (state) => {},

    [DeletePaymentCredit.fulfilled]: (state, { payload }) => {},
    [DeletePaymentCredit.pending]: (state) => {},
    [DeletePaymentCredit.rejected]: (state) => {},

    [getUser.fulfilled]: (state, { payload }) => {
      Object.assign(state, payload.data.data);
    },
    [getUser.pending]: (state) => {
      state.isUpdating = true;
    },
    [getUser.rejected]: (state) => {
      state.isCreatingAccount = false;
    },

    [getAllUsers.fulfilled]: (state, { payload }) => {
      state.users = payload?.data?.data;
      state.gettingUsers = false;
    },
    [getAllUsers.pending]: (state) => {
      state.isUpdating = true;
      state.gettingUsers = true;
    },
    [getAllUsers.rejected]: (state) => {
      state.isCreatingAccount = false;
      state.gettingUsers = false;
    },
    [resendUserInvitation.fulfilled]: (state) => {
      state.isResendUserEmail = {
        isSendingEmail: false,
        resendEmail: null,
      };
    },
    [resendUserInvitation.pending]: (state, action) => {
      const resendEmail = action.meta.arg;
      state.isResendUserEmail = {
        isSendingEmail: true,
        resendEmail: resendEmail,
      };
    },
    [resendUserInvitation.rejected]: (state) => {
      state.isResendUserEmail = {
        isSendingEmail: false,
        resendEmail: null,
      };
    },
    [getAllRoleDetail.fulfilled]: (state, { payload }) => {
      state.userRoleList = payload?.data;
      state.userRoleLoader = false;
    },
    [getAllRoleDetail.pending]: (state) => {
      state.userRoleList = [];
      state.userRoleLoader = true;
    },
    [getAllRoleDetail.rejected]: (state) => {
      state.userRoleList = [];
      state.userRoleLoader = false;
    },

    [getOrganisationPermissionById.fulfilled]: (state, { payload }) => {
      state.userRoleList = payload?.data;
      state.oranganisationName = payload?.data?.[0]?.organisation?.name;
      state.getRoleByIdLoader = false;
    },
    [getOrganisationPermissionById.pending]: (state) => {
      state.userRoleList = [];
      state.getRoleByIdLoader = true;
    },
    [getOrganisationPermissionById.rejected]: (state) => {
      state.userRoleList = [];
      state.getRoleByIdLoader = false;
    },

    [getRoleById.fulfilled]: (state, { payload }) => {
      state.roleById = payload?.data;
      state.getRoleByIdLoader = false;
    },
    [getRoleById.pending]: (state) => {
      state.roleById = [];
      state.getRoleByIdLoader = true;
    },
    [getRoleById.rejected]: (state) => {
      state.roleById = [];
      state.getRoleByIdLoader = false;
    },

    [updateUser.fulfilled]: (state, { payload }) => {
      _.merge(state, payload.data.data);
    },
    [updateUserOrg.fulfilled]: (state, { payload }) => {
      state.organisation = payload.data.data;
    },
    [updateOrganisationAclDetails.fulfilled]: (state, { payload }) => {
      const data = payload?.data?.data;
      if (!data) return;
      if (data.organisation) {
        state.organisation = data.organisation;
      } else {
        state.organisation = { ...state.organisation, acl: data.acl ?? data };
      }
    },

    [updatePhoneNumber.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.successMessage = payload.message;
      Object.assign(state, payload.data.data);
    },
    [updatePhoneNumber.pending]: (state) => {
      state.isFetching = true;
    },
    [updatePhoneNumber.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [validateToken.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      Object.assign(state, payload?.data);
    },
    [validateToken.pending]: (state) => {
      state.isFetching = true;
    },
    [validateToken.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [validateEmail.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.emailInUse = payload.data.data.emailInUse;
    },
    [validateEmail.pending]: (state) => {
      state.isFetching = true;
    },
    [validateEmail.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [validatePhone.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.phoneInUse = payload.data.data.phoneInUse;
    },
    [validatePhone.pending]: (state) => {
      state.isFetching = true;
    },
    [validatePhone.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [updateSettings.fulfilled]: (state, { payload }) => {
      localStorage.token = payload.data.data.token;
      Object.assign(state, payload.data);
      state.templateSaveSuccess = true;
    },
    [updateSettings.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [getAllTransactions.fulfilled]: (state, { payload }) => {
      Object.assign(state.transactions, payload.data.data);
    },
    [getAllTransactions.rejected]: (state) => {
      state.isFetching = false;
      state.isError = true;
    },

    [createSubscription.fulfilled]: (state, { payload }) => {
      Object.assign(state, payload.data.data);
      state.isCreatingSubscription = false;
    },
    [createSubscription.pending]: (state) => {
      state.isCreatingSubscription = true;
    },
    [createSubscription.rejected]: (state) => {
      state.isCreatingSubscription = false;
    },

    [getCustomerBilling.fulfilled]: (state, { payload }) => {
      state.isCreatingSubscription = false;
      Object.assign(state, payload.data.data);
    },
    [getCustomerBilling.pending]: (state) => {
      state.isCreatingSubscription = true;
    },
    [getCustomerBilling.rejected]: (state) => {
      state.isCreatingSubscription = false;
    },

    [createLenderSetting.pending]: (state) => {
      state.lenderSettings = [];
    },
    [createLenderSetting.rejected]: (state) => {
      state.lenderSettings = [];
    },
    [createLenderSetting.fulfilled]: (state, { payload }) => {
      state.lenderSettings = payload?.data?.data;
    },

    [updateLenderSetting.pending]: (state) => {},
    [updateLenderSetting.rejected]: (state) => {},
    [updateLenderSetting.fulfilled]: (state, { payload }) => {
      state.lenderSettings = payload.data.data;
    },

    [deleteLenderSetting.pending]: (state) => {},
    [deleteLenderSetting.rejected]: (state) => {},
    [deleteLenderSetting.fulfilled]: (state, { payload }) => {
      state.lenderSettings = payload.data.data;
    },

    [submitTerms.fulfilled]: (state, { payload }) => {
      if (payload.data.data) Object.assign(state, payload.data.data.user);
      state.isUpdating = false;
      state.updateSuccess = true;
    },
    [submitTerms.pending]: (state) => {
      state.isUpdating = true;
    },
    [submitTerms.rejected]: (state) => {
      state.isCreatingAccount = false;
    },

    [acceptEmploymentIncomeVerificationTerms.pending]: (state) => {
      state.acceptingEmploymentIncomeVerificationTerms = true;
    },
    [acceptEmploymentIncomeVerificationTerms.fulfilled]: (state, { payload }) => {
      state.acceptingEmploymentIncomeVerificationTerms = false;
      const acceptedAt = payload?.data?.data?.employmentIncomeVerificationTermsAcceptedAt;
      if (acceptedAt) state.employmentIncomeVerificationTermsAcceptedAt = acceptedAt;
    },
    [acceptEmploymentIncomeVerificationTerms.rejected]: (state) => {
      state.acceptingEmploymentIncomeVerificationTerms = false;
    },

    [updateUserRole.pending]: (state) => {},
    [updateUserRole.rejected]: (state) => {},
    [updateUserRole.fulfilled]: (state, { payload }) => {
      // state.lenderSettings = payload.data.data;
    },
    [saveRolePermissions.pending]: (state) => {},
    [saveRolePermissions.rejected]: (state) => {},
    [saveRolePermissions.fulfilled]: (state, { payload }) => {
      // state.lenderSettings = payload.data.data;
    },
    [getOrganisationUser.pending]: (state) => {
      state.oraganisationUser = [];
    },
    [getOrganisationUser.rejected]: (state) => {
      state.oraganisationUser = [];
    },
    [getOrganisationUser.fulfilled]: (state, { payload }) => {
      state.oraganisationUser = payload?.data;
    },

    [updateUserRole.pending]: (state) => {},
    [updateUserRole.rejected]: (state) => {},
    [updateUserRole.fulfilled]: (state, { payload }) => {
      // state.lenderSettings = payload.data.data;
    },
    [saveRolePermissions.pending]: (state) => {},
    [saveRolePermissions.rejected]: (state) => {},
    [saveRolePermissions.fulfilled]: (state, { payload }) => {
      // state.lenderSettings = payload.data.data;
    },
    [getOrganisationUser.pending]: (state) => {
      state.oraganisationUser = [];
      state.usersLoader = true;
    },
    [getOrganisationUser.rejected]: (state) => {
      state.oraganisationUser = [];
      state.usersLoader = false;
    },
    [getOrganisationUser.fulfilled]: (state, { payload }) => {
      state.oraganisationUser = payload?.data;
      state.usersLoader = false;
    },

    [getAllUserPermissions.pending]: (state) => {},
    [getAllUserPermissions.rejected]: (state) => {},
    [getAllUserPermissions.fulfilled]: (state, { payload }) => {},
    [getUserPermissionsByUserId.pending]: (state) => {},
    [getUserPermissionsByUserId.rejected]: (state) => {},
    [getUserPermissionsByUserId.fulfilled]: (state, { payload }) => {},
    [updateUserPermissions.pending]: (state) => {},
    [updateUserPermissions.rejected]: (state) => {},
    [updateUserPermissions.fulfilled]: (state, { payload }) => {},
    [getAllUsersWithBasicInfo.pending]: (state) => {
      state.usersWithBasicInfoLoader = true;
    },
    [getAllUsersWithBasicInfo.rejected]: (state) => {
      state.usersWithBasicInfoLoader = false;
    },
    [getAllUsersWithBasicInfo.fulfilled]: (state, { payload }) => {
      state.usersWithBasicInfoList = payload?.data?.users || [];
      state.usersWithBasicInfoLoader = false;
    },
  },
});

export const { saveValue, resetState } = userSlice.actions;

export const userSelector = (state) => state.user;
export const userPermissionsSelector = (state) => state.user.permissions;
